import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { CRUD } from "@/shared/components";
import {
  AssistantPlansListQuery,
  AssistantPlanShowQuery,
} from "@/admin/entities/assistant";
import { AssistantPlanDetails } from "./AssistantPlanDetails";
import {
  AssistantPlansSchemas,
  useAssistantPlansManagement,
  type AssistantPlanRow,
} from "../model";

const editSchema: EditSchemaDefinition = {
  details: {
    label: "План",
    type: "show" as const,
    getTitle: () => "План",
    showComponent: AssistantPlanDetails,
    showQuery: AssistantPlanShowQuery,
  },
};

/** «Помощник» → «Планы»: только просмотр, планы создаёт и выполняет сотрудник в кабинете партнёра. */
export function AssistantPlans() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useAssistantPlansManagement();
  return (
    <CRUD<AssistantPlanRow>
      listQuery={AssistantPlansListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={AssistantPlansSchemas.filterSchema}
      editSchema={editSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
